import { render } from "./ResponsiveNavLink.vue?vue&type=template&id=1bc2fd97"
import script from "./ResponsiveNavLink.vue?vue&type=script&lang=js"
export * from "./ResponsiveNavLink.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__